var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnvelope = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 18"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "envelope_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 5275",
  fill: "#fff",
  d: "M0 0h24v18H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 34008",
  clipPath: "url(#envelope_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13283",
  d: "M21.659 0H2.342A2.449 2.449 0 0 0 0 2.539v12.923A2.449 2.449 0 0 0 2.342 18h19.317A2.449 2.449 0 0 0 24 15.462V2.539A2.449 2.449 0 0 0 21.659 0m-.1 2L12 8.665 2.441 2Zm.1 14H2.342C2.18 16 2 15.77 2 15.462V4.13l9.428 6.57a1 1 0 0 0 1.144 0L22 4.13v11.332c0 .309-.181.538-.341.538",
  fill: "#fff"
}))));
export default SvgEnvelope;